import Vuex from 'vuex'
import Vue from 'vue'
import auth from './module/auth'
import application from './module/application'


Vue.use(Vuex)

export default new Vuex.Store({
    modules:{
        auth,
        application
    }
});